export default "__VITE_ASSET__SdwOkkV0__"